var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myskov-area__content" },
    [
      _vm.page == "offers" ? _c("saved-offers") : _vm._e(),
      _vm._v(" "),
      _vm.page == "orders" ? _c("myskov-orders") : _vm._e(),
      _vm._v(" "),
      _vm.page == "profile" ? _c("myskov-profile") : _vm._e(),
      _vm._v(" "),
      _vm.page == "newsletter" ? _c("myskov-newsletter") : _vm._e(),
      _vm._v(" "),
      _vm.page == "help" ? _c("myskov-help") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28db95e2", { render: render, staticRenderFns: staticRenderFns })
  }
}